import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset window scroll when the route changes so new pages open at the first section. */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}
